<template>
  <div class="page-container">
    <md-app md-mode="reveal">
      <md-app-toolbar class="md-primary">
        <Header :menuVisible="menuVisible" v-on:toggleMenu="toggleMenu"/>
      </md-app-toolbar>

      <md-app-drawer :md-active.sync="menuVisible">
        <Menu :menuVisible="menuVisible"/>
      </md-app-drawer>

      <md-app-content>
        <div>
            <md-dialog-confirm
                :md-active.sync="deleteConfirm"
                md-title="Confirmación"
                md-content="¿Desea elminar este establecimiento?"
                md-confirm-text="Borrar"
                md-cancel-text="Cancelar"
                @md-cancel="deleteConfirm = false"
                @md-confirm="onDeleteConfirm" />

            <md-content v-if="showDialog">
                <form novalidate class="md-layout" @submit.prevent="validateItem">
                <md-card class="md-layout-item">
                    <md-card-header>
                    <div class="md-title" v-if="!formForEdit">Nuevo establecimiento</div>
                    <div class="md-title" v-if="formForEdit">Modificar establecimiento</div>
                    </md-card-header>

                    <md-card-content>
                        <md-field>
                            <label for="name">Nombre</label>
                            <md-input name="name" id="name" v-model="form.name" :disabled="sending" />
                        </md-field>

                        <md-field>
                            <label for="name">Descripción</label>
                            <md-input name="description" id="description" v-model="form.description" :disabled="sending" />
                        </md-field>

                        <md-field>
                            <label for="status">Estado</label>
                            <md-select name="status" id="status" v-model="form.status">
                                <md-option value="revision" :disabled="!acl.createsSchools && !acl.modifiesSchools">En revisión</md-option>
                                <md-option value="active" :disabled="!acl.aprovesSchools">Activo</md-option>
                                <md-option value="suspended" :disabled="!acl.suspendsSchools">Suspendido</md-option>
                            </md-select>
                        </md-field>
                    </md-card-content>

                    <md-progress-bar md-mode="indeterminate" v-if="sending" />

                    <md-card-actions>
                    <md-button class="md-accent" @click="cancelForm()">Cancelar</md-button>
                    <md-button type="submit" class="md-primary" :disabled="sending">Guardar</md-button>
                    </md-card-actions>
                </md-card>

                </form>
            </md-content>

            <md-table v-model="schools" md-sort="name" md-sort-order="asc" v-if="!showDialog" md-card md-fixed-header>
                <md-table-toolbar>
                    <h1 class="md-title">Establecimientos Educativos y Polideportivos</h1>
                    <md-button class="md-fab md-primary" @click="showForm()" v-if="acl.createsSchools && !loading">
                        <md-icon>add</md-icon>
                    </md-button>

                    <md-content class="text-xs-center" v-if="loading">
                        <p class="md-subheading md-layout md-alignment-top-center" v-bind:style="{ width: '100%' }">Cargando...</p>
                    </md-content>
                </md-table-toolbar>

                <md-table-row slot="md-table-row" slot-scope="{ item }" v-if="!loading">
                    <md-table-cell md-label="Nombre" md-sort-by="name">{{ item.name }}</md-table-cell>
                    <md-table-cell md-label="Miembros" md-sort-by="qtyPlayers">{{ item.qtyPlayers }}</md-table-cell>
                    <md-table-cell md-label="Estado" md-sort-by="qtyQuestions">{{ (item.status == 'active') ? 'Activo' : (item.status == 'revision') ? 'En Revisión' : 'Suspendido' }}</md-table-cell>
                    <md-table-cell class="actions-cell">
                        <md-button class="md-icon-button md-primary" @click="editItem(item)" v-if="acl.modifiesSchools">
                            <md-icon>edit</md-icon>
                        </md-button>
                        <md-button class="md-icon-button md-accent" @click="deleteItem(item)" v-if="acl.deletesSchools">
                            <md-icon>delete</md-icon>
                        </md-button>
                    </md-table-cell>
                </md-table-row>
            </md-table>
        </div>
      </md-app-content>
    </md-app>
  </div>
</template>

<style lang="scss" scoped>
  .md-app {
    border: 1px solid rgba(#000, .12);
  }
  .md-dialog {
    max-width: 768px;
  }
  .actions-cell {
    text-align: right;
  }
  .md-select-content {
    z-index: 9999;
  }
</style>

<script>
import Header from './Header.vue';
import Menu from './Menu.vue';
import firebase from 'firebase';
import {config} from '../helpers/apiConfig'
import {user} from '../helpers/user'
import axios from "axios";

export default {
    name: 'Schools',
    components: {
        Header, Menu
    },
    data: () => ({
        menuVisible: false,
        loading: false,
        deleteConfirm: false,
        deleteItemId: null,
        schools: [],
        showDialog: false,
        form: {
            name: null,
            description: null,
            status: null
        },
        formForEdit: false,
        sending: false,
        lastUser: null,
        acl: {
            createsSchools: false,
            modifiesSchools: false,
            aprovesSchools: false,
            suspendsSchools: false,
            deletesSchools: false
        }
    }),
    mounted() {
        firebase.auth().onAuthStateChanged((liuser) => {
            if (liuser) {
                console.log('User logged in, go ahead...');
                var that = this;
                user.init(firebase.auth().currentUser, () => {
                    that.fetchData();
                });
            } else {
                this.$router.push('/auth')
                console.log('User not logged in!');
            }
        });
    },
    watch: {
        // call again the method if the route changes
        '$route': 'fetchData'
    },
    methods: {
        toggleMenu () {
            this.menuVisible = !this.menuVisible
        },
        fetchData () {
            this.schools = [];
            this.loading = true;
            this.acl = {
                createsSchools: user.hasPermission('createsSchools'),
                modifiesSchools: user.hasPermission('modifiesSchools'),
                aprovesSchools: user.hasPermission('aprovesSchools'),
                suspendsSchools: user.hasPermission('suspendsSchools'),
                deletesSchools: user.hasPermission('deletesSchools')
            }
            console.log('this.acl', this.acl);

            axios({ 
                "method": "GET", 
                "url": config.apiUrl + "/school", 
                "headers": { "content-type": "application/json", "X-Auth": user.token } }
            ).then(result => {
                    console.log(result.data);
                    this.loading = false;
                    this.schools = result.data;
                }, error => {
                    console.error(error);
                    this.loading = false;
                    alert("Ocurrió un problema en la comunicación con el servidor!\n\n" + error);
                }
            );
        },
        validateItem () {
            let validationError = false;
            if (!this.form.name) {
                validationError = true;
                alert('falta nombre');
            }

            if (!validationError) {
                if (this.formForEdit) {
                    axios({ 
                        "method": "PUT", 
                        "url": config.apiUrl + "/school/" + this.editItemId, 
                        "data": this.form, 
                        "headers": { "content-type": "application/json", "X-Auth": user.token } }
                    ).then(result => {
                            console.log(result);
                            this.hideForm();
                            this.cleanForm();
                            this.fetchData();
                        }, error => {
                            console.error(error);
                            alert("Ocurrió un problema en la comunicación con el servidor!\n\n" + error);
                        }
                    );
                } else {
                    axios({ 
                        "method": "POST", 
                        "url": config.apiUrl + "/school", 
                        "data": this.form, 
                        "headers": { "content-type": "application/json", "X-Auth": user.token } }
                    ).then(result => {
                            console.log(result);
                            this.hideForm();
                            this.cleanForm();
                            this.fetchData();
                        }, error => {
                            console.error(error);
                            alert("Ocurrió un problema en la comunicación con el servidor!\n\n" + error);
                        }
                    );
                }
            }
        },
        cleanForm () {
            this.form = {
                name: null,
                description: null,
                status: null
            }
            this.formForEdit = false;
            this.editItemId = null;
        },
        showForm () {
            this.showDialog = true;
        },
        hideForm () {
            this.showDialog = false;
        },
        cancelForm () {
            this.hideForm();
            this.cleanForm();
        },
        editItem (item) {
            console.log(item);
            this.form = {
                name: item.name,
                description: item.description,
                status: item.status
            }
            this.formForEdit = true;
            this.editItemId = item.id;
            this.showForm();
        },
        deleteItem (item) {
            this.deleteConfirm = true;
            this.deleteItemId = item.id;
        },
        onDeleteConfirm () {
            axios({ 
                "method": "DELETE", 
                "url": config.apiUrl + "/school/" + this.deleteItemId, 
                "headers": { "content-type": "application/json", "X-Auth": user.token } }
            ).then(result => {
                    console.log(result);
                    this.fetchData();
                }, error => {
                    console.error(error);
                    alert("Ocurrió un problema en la comunicación con el servidor!\n\n" + error);
                }
            );
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Schools.vue